import { create } from 'zustand';
import type { OfflineQueueEntry } from '@/lib/offline/types';

interface OfflineQueueState {
  entries: Record<string, OfflineQueueEntry>;
  replaceAll: (entries: OfflineQueueEntry[]) => void;
  upsert: (entry: OfflineQueueEntry) => void;
  patch: (id: string, patch: Partial<OfflineQueueEntry>) => void;
  clear: () => void;
}

export const useOfflineQueueStore = create<OfflineQueueState>((set) => ({
  entries: {},
  replaceAll: (entries) => {
    const map = entries.reduce<Record<string, OfflineQueueEntry>>((acc, entry) => {
      acc[entry.id] = entry;
      return acc;
    }, {});
    set({ entries: map });
  },
  upsert: (entry) => {
    set((state) => {
      const previous = state.entries[entry.id];
      return {
        entries: {
          ...state.entries,
          [entry.id]: previous ? { ...previous, ...entry } : entry,
        },
      };
    });
  },
  patch: (id, patch) => {
    set((state) => {
      const existing = state.entries[id];
      if (!existing) {
        return state;
      }
      return {
        entries: {
          ...state.entries,
          [id]: { ...existing, ...patch },
        },
      };
    });
  },
  clear: () => {
    set({ entries: {} });
  },
}));

export const offlineQueueStore = useOfflineQueueStore;
